/**
 * The text of one step, whatever shape it is stored in. A catalogue recipe may
 * hold `{ number, step }` or a plain string; reading `.step` off a string is
 * `undefined`, which is how 26 recipes were translated into blank steps (#737).
 */
export function stepTextOf(step: unknown): string {
  if (typeof step === 'string') return step.trim();
  if (!step || typeof step !== 'object') return '';
  const text = (step as { step?: unknown }).step;
  return typeof text === 'string' ? text.trim() : '';
}
